import { Link, useNavigate } from 'react-router-dom';

import { Button } from '../../components/ui';

import * as Styled from './PageNotFound.styles';

import navigationPaths from 'engine/navigationPaths';
import { resources } from 'oems/resources';

export default function PageNotFound() {
  const navigate = useNavigate();

  return (
    <Styled.Wrapper>
      <Styled.LeftDescription>
        <img src={resources.logoDarkImage} alt="logo" className="logo" />
        <Styled.Content>
          <Styled.Title>Oooops, sorry!</Styled.Title>
          Podana strona nie istnieje. Sprawdź czy wprowadzony adres jest prawidłowy lub skorzystaj z poniżyszch opcji.
          <Button variant="contained" onClick={() => navigate(navigationPaths().Invoices)}>
            Zabierz mnie do moich Faktur
          </Button>
        </Styled.Content>
      </Styled.LeftDescription>
      <Styled.RightDescription></Styled.RightDescription>
    </Styled.Wrapper>
  );
}
